{
  "nav": {
    "home": "Startseite",
    "scouting": "Scouting",
    "reports": "Berichte",
    "settings": "Einstellungen"
  },
  "settings": {
    "language": "Sprache",
    "languageDescription": "Wählen Sie die in der App verwendete Sprache.",
    "save": "Speichern"
  },
  "reports": {
    "title": "Scouting-Berichte",
    "empty": "Noch keine Berichte",
    "generateSummary": "Zusammenfassung erstellen",
    "translationUnavailable": "Übersetzung nicht verfügbar. Der Originalbericht wird angezeigt.",
    "retryTranslation": "Erneut versuchen",
    "matchesHeading_one": "Spiel:",
    "matchesHeading_other": "Spiele:",
    "matchLineHome": "gegen {{opponent}} am {{date}}",
    "matchLineAway": "bei {{opponent}} am {{date}}",
    "matchLineNeutral": "{{opponent}} am {{date}}",
    "editorTitle": "Scouting-Bericht bearbeiten",
    "untitled": "Bericht",
    "authorSelf": "Sie",
    "sharedBadge": "Geteilt",
    "shareAction": "Teilen",
    "sharedAction": "Geteilt",
    "back": "Zurück",
    "editedBy": "Bearbeitet von",
    "createdBy": "Erstellt von",
    "translate": "Übersetzen",
    "translating": "Übersetzen...",
    "showOriginal": "Original anzeigen",
    "download": "Herunterladen",
    "downloading": "Wird heruntergeladen...",
    "edit": "Bearbeiten",
    "archive": "Archivieren"
  },
  "language": {
    "control": "Sprache",
    "selectTitle": "Sprache auswählen",
    "change": "Sprache ändern",
    "changeCurrent": "Sprache ändern, derzeit {{language}}",
    "changeStranded": "Sprache ändern. Ihre gespeicherte Sprache {{code}} wird nicht mehr angeboten, daher wird stattdessen {{language}} verwendet.",
    "generate": "Erstellen · {{language}}",
    "generateAccessibility": "Sprache der erstellten Zusammenfassung",
    "saveDefault": {
      "idle": "Als meine Standardsprache speichern",
      "saving": "Wird gespeichert…",
      "saved": "Als Ihre Standardsprache gespeichert",
      "alreadyDefault": "Das ist bereits Ihre Standardsprache",
      "error": "Speichern fehlgeschlagen – zum Wiederholen tippen",
      "warning": "Gilt nur für diese Zusammenfassung. Speichern Sie sie als Standardsprache, sonst müssen Sie sie beim nächsten Mal neu erstellen.",
      "errorAccessible": "{{label}}. {{reason}}",
      "failed": "Ihre Standardsprache konnte nicht gespeichert werden. Bitte versuchen Sie es erneut."
    }
  }
}
